import batch from './batch';
import cloud from './cloud';
import node from './cloud';

export default { batch, cloud, node };
